import { render, staticRenderFns } from "./PermissionSelect.vue?vue&type=template&id=376202be"
import script from "./PermissionSelect.vue?vue&type=script&lang=js"
export * from "./PermissionSelect.vue?vue&type=script&lang=js"
import style0 from "./PermissionSelect.vue?vue&type=style&index=0&id=376202be&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('376202be')) {
      api.createRecord('376202be', component.options)
    } else {
      api.reload('376202be', component.options)
    }
    module.hot.accept("./PermissionSelect.vue?vue&type=template&id=376202be", function () {
      api.rerender('376202be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/menu/components/PermissionSelect.vue"
export default component.exports